<template>
  <div class="popup-body">
    <div ref="stickySentinel" class="sentinel"></div>
    <div class="terms-privacy">
      <div class="tp-cont">
        <p class="tp-cont-txt">개인정보 처리방침 주식회사 현대이지웰 Hcon 이하(‘Hcon’ 이라 한다.)는 고객의 개인정보를 보호하고 이와 관련한 고통을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리방침을 수립ㆍ공개합니다.</p>
      </div>
      <div class="terms-privacy-list" :class="{'is-sticky': isSticky, 'is-expanded': isExpanded}">
        <p class="tos-tit">목차</p>
        <ul>
          <li><NuxtLink to="#tp-spec1-1" @click="resetBeforeMove">1.	개인정보의 수집항목 및 이용목적</NuxtLink></li>
          <li>
            <NuxtLink to="#tp-spec1-2" @click="resetBeforeMove">2.	개인정보의 보유 및 이용기간</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-3" @click="resetBeforeMove">3.	개인정보의 제3자 제공</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-4" @click="resetBeforeMove">4.	개인정보처리의 위탁</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-5" @click="resetBeforeMove">5.	개인정보 파기절차 및 방법</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-6" @click="resetBeforeMove">6.	개인정보의 안전성 확보조치</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-7" @click="resetBeforeMove">7.	개인정보 자동 수집장치의 설치/운영 및 거부에 관한 사항</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-8" @click="resetBeforeMove">8.	회원의 권리와 의무</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-9" @click="resetBeforeMove">9.	개인정보 보호책임자</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-10" @click="resetBeforeMove">10.	개인정보침해 관련 상담 신고</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-11" @click="resetBeforeMove">11.	개인정보처리방침 고지/변경의 의무</NuxtLink>
          </li>
        </ul>
        <button type="button" v-if="isSticky && !isExpanded" class="more-badge" @click="isExpanded = !isExpanded"></button>
      </div>
      <div class="terms-privacy-cont">
        <p class="tp-tit02" id="tp-spec1-1">제1조 개인정보의 수집항목 및 이용목적</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">
            Hcon은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
          </p>
          <table class="tbl-type terms mt10">
            <caption>개인정보의 수집항목 및 이용목적 목록</caption>
            <colgroup>
              <col style="width: 10%" />
              <col style="width: 25%" />
              <col style="width: 10%" />
              <col style="width: auto" />
              <col style="width: 15%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">수집방법</th>
                <th scope="col">이용목적</th>
                <th scope="col">유형</th>
                <th scope="col">수집항목</th>
                <th scope="col">이용기간 및 보유기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="2">회원가입</td>
                <td rowspan="2">Hcon 회원관리, 서비스 제공, 고객상담 및 고객불만 접수 및 처리</td>
                <td>필수</td>
                <td>아이디, 비밀번호, 휴대전화번호, 이름, 이메일, CI/DI</td>
                <td rowspan="3">동의 철회 또는 탈퇴 후 30일</td>
              </tr>
              <tr>
                <td>선택</td>
                <td>소속정보(부서,직급), 유선 전화번호</td>
              </tr>
              <tr>
                <td>본인인증</td>
                <td>본인인증</td>
                <td>필수</td>
                <td>이름, 생년월일, 성별, 휴대전화번호, CI/DI</td>
              </tr>
              <tr>
                <td rowspan="3">주문</td>
                <td rowspan="2">상품 배송 및 배송지 관리</td>
                <td>필수</td>
                <td>배송정보(휴대전화번호)</td>
                <td rowspan="6">5년(전자상거래법 제6조)</td>
              </tr>
              <tr>
                <td>선택</td>
                <td>배송정보(이름)</td>
              </tr>
              <tr>
                <td>핀발행</td>
                <td>필수</td>
                <td>이름, 휴대전화번호, 이메일주소</td>
              </tr>
              <tr>
                <td rowspan="3">결제</td>
                <td>결제 및 환불</td>
                <td>필수</td>
                <td>신용카드번호, 계좌번호, 휴대전화번호</td>
              </tr>
              <tr>
                <td>H캐시 충전 및 환불</td>
                <td>필수</td>
                <td>신용카드번호, 계좌번호, 휴대전화번호</td>
              </tr>
              <tr>
                <td>환불계좌 관리</td>
                <td>필수</td>
                <td>은행명, 환불계좌번호, 예금주명, 통장사본</td>
              </tr>
              <tr>
                <td rowspan="2">견적요청</td>
                <td>회원 견적 요청</td>
                <td>필수</td>
                <td>이름</td>
                <td rowspan="2">견적 유효기간 동안(14일)</td>
              </tr>
              <tr>
                <td>비회원 견적 요청</td>
                <td>필수</td>
                <td>이름</td>
              </tr>
              <tr>
                <td>연락처 관리</td>
                <td>수신인 사전 등록</td>
                <td>필수</td>
                <td>이름,휴대전화번호</td>
                <td rowspan="2">동의 철회 또는 탈퇴 후 30일</td>
              </tr>
              <tr>
                <td>마케팅</td>
                <td>이벤트, 맞춤형 서비스 제공</td>
                <td>선택</td>
                <td>이름, 생년월일, 성별, 휴대전화번호, 이메일</td>
              </tr>
            </tbody>
          </table>
          <p class="tp-cont-txt mt10">※ 소득세법에 따라 경품 지급 등을 위한 제세공과금 처리 목적으로 주민등록번호, 계좌번호 등을 수집할 수 있습니다.</p>
          <br />
          <p class="tp-cont-txt">[제공받는 개인정보 자세히 보기]</p>
          <table class="tbl-type terms mt10">
            <caption>제공받는 개인정보 목록</caption>
            <colgroup>
              <col style="width: 35%" />
              <col style="width: auto" />
              <col style="width: 35%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">수집방법</th>
                <th scope="col">이용목적</th>
                <th scope="col">유형</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Hcas 시스템<br />(현대이지웰)</td>
                <td>SSO 연동</td>
                <td>휴대전화번호</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="tp-tit02" id="tp-spec1-2">제2조 개인정보의 보유 및 이용기간</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">Hcon은 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기 합니다. 단, 관련 법령의 규정에 의하여 다음과 같이 거래 관련 관리 의무 관계의 확인 등을 이유로 일정기간 보유하여야 할 필요가 있을 경우에는 일정기간 보유합니다.</p>
          <table class="tbl-type terms mt10">
            <caption>개인정보의 보유 및 이용기간 목록</caption>
            <colgroup>
              <col style="width: 33%" />
              <col style="width: auto" />
              <col style="width: 33%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">근거법령</th>
                <th scope="col">조문</th>
                <th scope="col">보유기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>통신비밀보호법</td>
                <td>통신사실 확인자료 기록</td>
                <td>3개월</td>
              </tr>
              <tr>
                <td rowspan="3">전자상거래 등에서의 소비자 보호에 관한 법률</td>
                <td>계약 또는 청약철회 등에 관한 기록</td>
                <td>5년</td>
              </tr>
              <tr>
                <td>대금결제 및 재화 등의 공급에 관한 기록</td>
                <td>5년</td>
              </tr>
              <tr>
                <td>소비자의 불만 또는 분쟁처리에 관한 기록</td>
                <td>3년</td>
              </tr>
            </tbody>
          </table>
          <p class="tp-cont-txt mt10">상기 사유 이외에 다음의 예외적인 사유에 해당하는 경우 해당 사유 종료 시까지 개인정보를 보유합니다.</p>
          <ol class="ol-list">
            <li>1) 관계 법령 위반에 따른 수사 · 조사 등이 진행 중인 경우 : 해당 수사 · 조사 종료 시까지</li>
            <li>2) 서비스 이용에 따른 채권 · 채무관계 잔존할 경우: 해당 채권 · 채무관계 정산 시까지</li>
            <li>3) 재화 또는 서비스 제공의 경우: 재화 · 서비스 공급완료 및 요금결제 · 정산 완료 시까지</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-3">제3조 개인정보의 제3자 제공</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">Hcon 은 개인정보를 제3자에게 제공하지 않습니다. 개인정보 제3자 제공이 필요한 경우에는 합당한 절차를 통한 회원의 동의를 얻어 제3자에게 개인정보를 제공 할 수 있습니다. 동의를 거부하시는 경우에도 Hcon을 이용하실 수 있으나, 제 3자 제공에 기반한 관련 서비스의 이용이 제한될 수 있습니다.</p>
          <p class="tp-cont-txt mt10">다음사항은 예외적으로 동의 없이 개인정보 제공이 가능합니다.</p>
          <ol class="ol-list">
            <li>1) 수사목적으로 관계법률에서 정한 절차와 방법에 따라 수사기관이 개인정보 제공을 요구하는 경우</li>
            <li>2) 통계작성, 학술연구나 시장조사 등을 위하여 특정 개인을 식별할 수 없는 형태로 광고주, 협력사나 연구단체에서 요구하는 경우</li>
            <li>3) 기타 관련법률의 규정에 따른 요청이 있는 경우</li>
            <li>4) 영업의 양도, 합병 등</li>
          </ol>
          <p class="tp-cont-txt">※ 영업의 양도 등에 관한 사유가 발생하여 회원의 개인정보 이전이 필요한 경우, 관계법률에서 규정한 절차와 방법에 따라 개인정보 이전에 관한 사실 등을 사전에 고지하며, 개인정보 이전에 관한 동의 철회권을 부여합니다.</p>
        </div>
        <p class="tp-tit02" id="tp-spec1-4">제4조 개인정보처리의 위탁</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">
            Hcon은 기본적인 서비스의 제공, 서비스의 유지 및 관리, 고객 편의 제공 등 서비스에 반드시 필요한 업무 중 일부를 외부 전문업체에 위탁하여 운영하고 있습니다.
          </p>
          <p class="tp-cont-txt">개인정보 처리 위탁 기관 및 위탁업무의 내용은 아래와 같습니다.</p>
          <table class="tbl-type terms mt10">
            <caption>개인정보의 보유 및 이용기간 목록</caption>
            <colgroup>
              <col style="width: 50%" />
              <col style="width: 50%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">위탁받는 자</th>
                <th scope="col">위탁하는 업무의 내용</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>나이스평가정보(주)</td>
                <td>본인확인 서비스(PASS 인증)</td>
              </tr>
              <tr>
                <td>(주)케이지이니시스</td>
                <td>결제처리 서비스, 계좌인증 서비스</td>
              </tr>
              <tr>
                <td>현대퓨처넷</td>
                <td>카카오 알림톡 발송</td>
              </tr>
              <tr>
                <td>서울평가정보(주)</td>
                <td>기업실명확인 서비스</td>
              </tr>
              <tr>
                <td>에스케이(주)</td>
                <td>클라우드 인프라 유지관리</td>
              </tr>
              <tr>
                <td>아마존웹서비스코리아(유)</td>
                <td>클라우드 인프라 운영 및 관리(국내 리전)</td>
              </tr>
            </tbody>
          </table>
          <p class="tp-cont-txt mt10">Hcon은 위탁계약 체결 시 위탁업무 수행목적 외 개인정보 처리금지, 기술적 관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리 감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>
          <p class="tp-cont-txt">위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</p>
        </div>
        <p class="tp-tit02" id="tp-spec1-5">제5조 개인정보 파기절차 및 방법</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">Hcon은 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 해당 개인정보를 지체없이 파기합니다.</p>
          <p class="tp-cont-txt">단, 회사방침 및 관계법령에 의해 보관할 필요가 있는 경우 해당 개인정보를 별도의 데이터베이스로 옮기거나 보관장소를 달리하여 보존합니다.</p>
          <ol class="ol-list">
            <li>1&#41; 파기절차
              <ul class="tp-cont-ul">
                <li>- 파기 사유가 발생한 개인정보를 선정하고, Hcon의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</li>
              </ul>
            </li>
            <li>2&#41; 파기방법
              <ul class="tp-cont-ul">
                <li>- 종이에 출력된 개인정보 : 분쇄기로 분쇄하거나 소각</li>
                <li>- 전자적 파일 형태로 저장된 개인정보 : 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제</li>
              </ul>
            </li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-6">제6조 개인정보의 안전성 확보조치</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">Hcon은 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
          <ol class="ol-list">
            <li>1&#41; 관리적 조치
              <ul class="tp-cont-ul">
                <li>- 개인정보에 대한 접근권한을 최소화 하고 있습니다.</li>
                <li>- 내부규정 및 절차 등을 마련하고 소속 임직원들의 정기적인 개인정보보호 교육 진행과 자가보안 진단을 매월 실시하고 있습니다</li>
              </ul>
            </li>
            <li>2&#41; 기술적 조치
              <ul class="tp-cont-ul">
                <li>- 개인정보를 암호화하여 저장 및 관리하고 있습니다.</li>
                <li>- 다양한 보안 위협으로부터 안전하게 지키기 위하여 DDoS 공격 대응장비와 침입방지시스템 등의 보안장비를 운영하고 있으며 백신을 사용하여 바이러스, 악성코드 등에 의한 피해를 방지하고 침해사고에 실시간 대응을 위해 365일 보안관제를 통해 침입을 감지하고 있습니다.</li>
                <li>- 전사적으로 인터넷망과 내부망을 분리하여 개인정보 유출 가능성을 최소화 하고 있습니다.</li>
              </ul>
            </li>
            <li>3&#41; 물리적 조치
              <ul class="tp-cont-ul">
                <li>- 사내 규정에 의거하여 보호구역을 지정하여 출입을 엄격히 통제하고 있습니다.</li>
                <li>- 중요 시스템에 대한 분리 운영 및 24시간 관리감독을 철저히 이행하고 있습니다.</li>
              </ul>
            </li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-8">제7조 회원의 권리와 의무</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">고객은 언제든지 다음 각 호의 개인정보 보호권리를 행사할 수 있습니다.</p>
          <ol class="ol-list">
            <li>1&#41; 개인정보 열람요구</li>
            <li>2&#41; 오류 등이 있을 경우 정정 요구</li>
            <li>3&#41; 삭제요구</li>
            <li>4&#41; 처리정지 요구</li>
          </ol>
          <p class="tp-cont-txt">
            제1항에 따른 권리 행사는 Hcon에 대해 서면, 전화, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 Hcon은 이에 대해 지체 없이 조치하겠습니다.
          </p>
          <p class="tp-cont-txt">
            고객이 개인정보 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 Hcon은 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.
          </p>
          <p class="tp-cont-txt">
            고객은 정보통신망법, 개인정보보호법 등 관계법령을 위반하여 Hcon이 처리하고 있는 고객 본인이나 타인의 개인정보 및 사생활을 침해하여서는 안됩니다.
          </p>
        </div>
        <p class="tp-tit02" id="tp-spec1-9">제8조 개인정보 보호책임자</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">
            Hcon은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 고객의 불만처리 및 피해구제 등을 위하여 다음과 같이 개인정보 보호책임자를 지정 · 운영하고 있습니다.
          </p>
          <table class="tbl-type terms mt10">
            <caption>개인정보 보호책임자 목록</caption>
            <colgroup>
              <col style="width: 25%" />
              <col style="width: 25%" />
              <col style="width: 25%" />
              <col style="width: auto" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">이름</th>
                <th scope="col">소속</th>
                <th scope="col">연락처</th>
                <th scope="col">이메일</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>김충진 상무</td>
                <td>복지컨설팅사업부</td>
                <td>02-2131-6565</td>
                <td>ez_privacy@hyundaiezwel.com</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="tp-tit02" id="tp-spec1-10">제9조 개인정보침해 관련 상담신고</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">
            고객은 아래의 기관에 대해 개인정보 침해에 대한 피해규제, 상담 등을 문의하실 수 있습니다.
          </p>
          <p class="tp-cont-txt">
            &lt;아래의 기관은 Hcon과 별개의 기관으로서 Hcon의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다.&gt;
          </p>
          <table class="tbl-type terms mt10">
            <caption>개인정보침해 관련 상담신고 목록</caption>
            <colgroup>
              <col style="width: 33.33%" />
              <col style="width: 33.33%" />
              <col style="width: 33.33%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">구분</th>
                <th scope="col">연락처</th>
                <th scope="col">홈페이지</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>개인정보 침해신고센터</td>
                <td>(국번없이) 118</td>
                <td>privacy.kisa.or.kr</td>
              </tr>
              <tr>
                <td>개인정보 분쟁조정위원회</td>
                <td>(국번없이) 1833-6972</td>
                <td>kopico.go.kr</td>
              </tr>
              <tr>
                <td>대검찰청 사이버수사과</td>
                <td>(국번없이) 1301</td>
                <td>spo.go.kr</td>
              </tr>
              <tr>
                <td>경찰청 사이버수사국</td>
                <td>(국번없이) 182</td>
                <td>ecrm.police.go.kr</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="tp-tit02" id="tp-spec1-11">제10조 개인정보처리방침 고지/변경의 의무</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">
            이 개인정보처리방침은 2026.04.17. 부터 적용됩니다.<br />
            이전의 개인정보처리방침은 아래에서 확인하실 수 있습니다.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onUnmounted, nextTick } from 'vue';

const props = defineProps({
  isTermsPopupOpen: {
    type: Boolean
  }
})

const isSticky = ref(false)
const isExpanded = ref(false)
const stickySentinel = ref<HTMLElement | null>(null)

let observer: IntersectionObserver | null = null

const resetBeforeMove = async () => {
  isExpanded.value = false
  await nextTick()

  const listEl = document.querySelector('.popup-body .terms-privacy-list') as HTMLElement
  if (listEl) {
    listEl.scrollTo({ top: 0 })
  }
}

const initObserver = () => {
  if (observer) observer.disconnect()

  const scrollEl = document.querySelector('.popup-body') as HTMLElement
  if (!scrollEl || !stickySentinel.value) return

  observer = new IntersectionObserver(
    ([entry]) => {
      isSticky.value = !entry.isIntersecting

      if (entry.isIntersecting) {
        isExpanded.value = false

        const listEl = document.querySelector('.popup-body .terms-privacy-list') as HTMLElement
        if (listEl) {
          listEl.scrollTo({ top: 0 })
        }
      }
    },
    {
      root: scrollEl,
      threshold: 0,
      rootMargin: '10px 0px 0px 0px'
    }
  )

  observer.observe(stickySentinel.value)
}

watch(() => props.isTermsPopupOpen, async (newVal) => {
  if (newVal) {
    await nextTick()
    setTimeout(() => {
      initObserver()
    }, 100)
  } else {
    isSticky.value = false
    isExpanded.value = false
    if (observer) observer.disconnect()
  }
}, {immediate:true})

onUnmounted(() => {
  if (observer) observer.disconnect()
})

</script>
<style lang="scss" scoped>
</style>
